import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import htmlToPdfmake from "html-to-pdfmake";
import { formatNumber } from "../functions/formatters";
import { normalizeTable, sanitizeNaNValues, convertTableWidthsToPercent } from "../functions/pdfMake/normalizeTable";
import QRCode from "qrcode";
import { generateLink } from "../functions/renderProtocol";
import { asJSONSafe } from "../functions";
import htmlConverter from 'html2json';
import { normalizeHtml } from "../functions/html";
import { protocolModelFormatField } from "../models/protocolModel";
import { mapProtocolFieldNumber } from "../functions/viewDataMap";
import forms from "../screens/Protocol/ProtocolForms/forms";
import { where } from "../functions/linqSimulation";
import { translateLaboratoryNameToKz } from "../data/laboratoryRuKzMap";
import { normalizeHtmlTable, convertTableColumnWidthsToPercent, applyPdfRowspanClasses } from "../functions/pdfMake/normalizeHtmlTable";
import { rotateTextInTable } from "../functions/pdfMake/rotate";
import { grayscaleImage } from "../functions/pdfMake/grayscaleImage";

pdfMake.vfs = pdfFonts.pdfMake.vfs;


const renderEmployeePosition = (employee) => {
    let result = "";

    if (!employee?.position)
        return result;

    if (employee.position.nameKz && employee.position.name)
        return `${employee.position.nameKz} (${employee.position.name})`;

    return employee.position.name;
}

const renderEmployeeName = (employee) => {
    let result = "";

    if (!employee)
        return result;

    return employee.fullName;
}

class ProtocolPdfModel {

    constructor() {
        // Конструктор, если нужно, можно использовать для инициализации переменных
    }

    async generatePdf(protocol, addOptionalLogo, optionalLogoUrl, logoUrl, protocolData, signers, dateOfIssue, pageOrientation = 'auto', debugCanvas = false) {
        let maxTableColumns = 0;
        const form = forms[protocol.form?.number];

        const fields = form?.fields || [];
        const version = form?.version;

        console.log(fields);
        // if (tableFields.length == 0) {
        //     return "";
        // }
        //  const response = await QRCode.toDataURL(url);
        const data = asJSONSafe(protocol.data);
        let qrLink = null;

        let link = generateLink(protocol.id, protocol.guid);
        if (link) {
            qrLink = await QRCode.toDataURL(link.url)
        }


        const content = [];
        const htmlTablesContent = [];

        const primitiveFields = fields.filter(f => f.type !== 'table');
        const tableFields = fields.filter(f => f.type === 'table' && f.version >= 2);
        
        let fieldNumber = 0;
        for (let i = 0; i < primitiveFields.length; i++) {
            const field = primitiveFields[i];
            const label = field.label;
            const id = field.id;
        
            const currentFieldNumber = fieldNumber;
            if (!field.skipNumber) {
                fieldNumber++;
            }
        
            // Если это скетч — рендерим его прямо в нужном месте
            if (field.type === "sketch" && data[field.id]) {
                content.push([
                    {
                        text: `${mapProtocolFieldNumber(field.number, currentFieldNumber, field.skipNumber)}${field.kazakhLabel || ''} (${field.label || 'Эскиз'})`,
                        bold: true,
                        margin: [0, 10, 0, 5],
                    },
                ]);
                if (data[field.id]?.pngBase64) {
                    content.push([
                        {
                            image: data[field.id]?.pngBase64,
                            height: 200,
                            alignment: 'center',
                            margin: [0, 0, 0, 10],
                        },
                    ]);
                }
            } else {
                // Обычные поля
                const value = protocolModelFormatField(field, data[field.id], field.type, field.convertor);
                content.push([
                    `${mapProtocolFieldNumber(field.number, currentFieldNumber, field.skipNumber)} ${field.kazakhLabel} (${label}): ${value || ""}`,
                ]);
            }
        }
        

        let k = 0;

        console.log('tables: ' + tableFields.length);

        const skipIndices = [1];
        const logHtml = true;
        const nodesIndex = null;
        const rowIndex = null;
        const columnIndex = null;

        for (let i = 0; i < tableFields.length; i++) {
            const field = tableFields[i];
            const label = field.label;

            // if (where(skipIndices, _ => _ == i).length > 0)
            //     continue;

            const id = field.id;
            try {
                //content.push([`${mapProtocolFieldNumber(field.number, i, field.skipNumber)} ${field.kazakhLabel} (${label})`]);
                let html = htmlConverter.json2html(data[id]);
                html = normalizeHtmlTable(html, 2);
                if (field.align) {
                    html = convertTableColumnWidthsToPercent(html);
                }
                console.log('normalized pdf html:' + html);

                let htmlPdfMake = htmlToPdfmake(html);

                // Очищаем NaN значения сразу после конвертации HTML
                htmlPdfMake = sanitizeNaNValues(htmlPdfMake);

                // pdf-rowspan-N с expandHtmlTableRowspans → настоящий rowSpan (обход бага html-to-pdfmake)
                applyPdfRowspanClasses(htmlPdfMake);

                //if (k == 0) {   

                if (nodesIndex != null) {
                    const node = htmlPdfMake[nodesIndex];
                    htmlPdfMake = [node];
                }

                htmlPdfMake.forEach(_ => {
                    normalizeTable(_, rowIndex, columnIndex);
                });

                // Очищаем NaN значения после нормализации таблиц
                htmlPdfMake = sanitizeNaNValues(htmlPdfMake);

                // Поворачиваем текст в ячейках с writing-mode: vertical-rl
                htmlPdfMake.forEach(tableNode => {
                    rotateTextInTable(tableNode, -90, debugCanvas);
                });

                if (logHtml)
                    console.log(htmlPdfMake);

                // if (htmlPdfMake.length == 1) {
                //     const table = htmlPdfMake[0].table;
                //     if (table && table.body?.length == 0) {
                //         continue;
                //     }
                // }

                htmlPdfMake.forEach(_ => {
                    if (_.table && _.table.body && _.table.body[0]) {
                        const colCount = _.table.body[0].length;
                        if (colCount > maxTableColumns) maxTableColumns = colCount;
                    }
                });

                if (field.align) {
                    htmlTablesContent.push({
                        marginTop: 10,
                        pageBreak: i === 0 ? 'before' : undefined,
                        stack: htmlPdfMake,
                    });
                } else {
                    htmlTablesContent.push({
                        pageBreak: i === 0 ? 'before' : undefined,
                        stack: htmlPdfMake,
                    });
                }
                //}
                k++;
            } catch (e) {
                content.push([e.toString()]);
                console.error(e);
            }
        }


        //      content.push([`Результат: ${data?.complied_with_regulatory_doc || data?.research_result || data?.research_results || ''}`]);

        const mmToPt = (mm) => mm * 2.83465;

        const images = [];
        const ilacScale = 20 / 18; // было 18×18 мм → 20×20 мм
        const ilacWmm = Math.round(22.62 * ilacScale);
        const ilacHmm = Math.round(22.62 * ilacScale);
        const ilacW = mmToPt(ilacWmm);
        const ilacH = mmToPt(ilacHmm);
        // Второй знак: от базы 21×23 мм (как было) ×1.3125 ширина, ×1.2941 высота, округление
        const filialLogoWmm = Math.round(21 * 1.3125*0.95);
        const filialLogoHmm = Math.round(24 * 1.2941*0.95);
        const filialLogoW = mmToPt(filialLogoWmm);
        const filialLogoH = mmToPt(filialLogoHmm);
        const logoSpacing = mmToPt(5); // расстояние 5 мм между логотипами

        if (optionalLogoUrl && addOptionalLogo) {
            const monochromeLogo = await grayscaleImage(optionalLogoUrl);
            images.push({ image: monochromeLogo, width: ilacW, height: ilacH });
        } else
            images.push('');
        if (logoUrl) {
            // ВАЖНО: отступ между логотипами задается отдельной колонкой (logoSpacing),
            // поэтому тут marginLeft = 0, иначе расстояние увеличивается при печати.
            images.push({ image: logoUrl, width: filialLogoW, height: filialLogoH, marginLeft: 0 });
        } else
            images.push('');

        const hasOptionalLogo = optionalLogoUrl && addOptionalLogo;
        const imagesCell = hasOptionalLogo ? {
            marginLeft: 5,
            layout: 'noBorders',
            table: {
                widths: [ilacW, filialLogoW],
                body: [
                    //[{ image: optionalLogoUrl, width: 50, height: 50 }, { image: logo, width: 50, height: 50 }, 'TEST']
                    [...images]

                ]
            }
        } : {
            marginLeft: 5,
            layout: 'noBorders',
            table: {
                widths: [0, filialLogoW],
                body: [
                    //[{ image: optionalLogoUrl, width: 50, height: 50 }, { image: logo, width: 50, height: 50 }, 'TEST']
                    [...images]
                ]
            }
        };

        // Шесть двуязычных колонок с длинными заголовками не помещаются в
        // полезную ширину портретного A4 и визуально обрезаются.
        const isWide = maxTableColumns > 5;
        // На некоторых формах с очень широкими таблицами (много колонок)
        // блок подписей и служебный текст визуально "наезжают" на сетку таблицы.
        // Для таких кейсов начинаем блок подписей с новой страницы.
        const shouldBreakBeforeSignatures = maxTableColumns >= 10;

        // Текст аккредитации зависит от выбранного логотипа (второго).
        // Если логотип не выбран — текст пустой.
        const accreditationInfo = protocolData?.accreditationInfo || {};

        // Новая схема (раздельно для KZ/RU)
        const regKz = accreditationInfo?.registeredAtKz || "";
        const regRu = accreditationInfo?.registeredAtRu || "";
        const validKz = accreditationInfo?.validUntilKz || "";
        const validRu = accreditationInfo?.validUntilRu || "";
        const markNumber = accreditationInfo?.markNumber || accreditationInfo?.markName || "";

        // Обратная совместимость со старой схемой (одно поле)
        const legacyReg = accreditationInfo?.registeredAt || "";
        const legacyValid = accreditationInfo?.validUntil || "";

        // Fallbacks:
        // - если RU не заполнено — используем KZ (и наоборот)
        // - если новая схема пустая — используем legacy поля
        const resolvedRegKz = regKz || regRu || legacyReg;
        const resolvedRegRu = regRu || regKz || legacyReg;
        const resolvedValidKz = validKz || validRu || legacyValid;
        const resolvedValidRu = validRu || validKz || legacyValid;

        const accreditationText =
            // показываем, если выбран логотип и заполнены минимум номер + дата регистрации + срок действия
            logoUrl && markNumber && (resolvedRegKz || resolvedRegRu) && (resolvedValidKz || resolvedValidRu)
                ? `Аккредиттеу аттестаты аккредиттеу субъектілерінің тізілімінде ${resolvedRegKz} № ${markNumber} болып тіркелген, ${resolvedValidKz} жарамды
Аттестат аккредитации зарегистрирован в реестре субъектов аккредитации №${markNumber} от ${resolvedRegRu}, действителен до ${resolvedValidRu}`
                : "";

        const codeText = `Нысанның БҚСЖ бойынша коды
Код формы по ОКУД ________
КҰЖЖ бойынша ұйым коды
Код организации по ОКПО ________`;

        const ministryText = `Қазақстан Республикасының Денсаулық сақтау министрлігі
Министерство здравоохранения Республики Казахстан`;

        const branchTextFallback = `ҚР ДСМ СЭБК "Ұлттық сараптама орталығы" ШЖҚ РМК Павлодар облысы бойынша филиалы
Филиал РГП на ПХВ "Национальный центр экспертизы" КСЭК МЗ РК по Павлодарской области
г. Павлодар`;

        const filialNameKz = protocol?.filial?.nameKz ?? protocol?.filial?.nameKZ ?? "";
        const filialNameRu = protocol?.filial?.name ?? protocol?.filial?.nameRu ?? protocol?.filial?.nameRU ?? "";
        
        // Названия районного отделения, если оно есть
        const filialDivisionNameKz = protocol?.filialDivision?.nameKz ?? protocol?.filialDivision?.nameKZ ?? "";
        const filialDivisionNameRu = protocol?.filialDivision?.name ?? protocol?.filialDivision?.nameRu ?? protocol?.filialDivision?.nameRU ?? "";
 
        const escapeRegExp = (s) => String(s ?? "").replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

        const extractCity = (s) => {
            const str = String(s ?? "").trim();
            if (!str) return "";
            // Явный формат "г. <город>"
            const mRu = str.match(/г\.\s*([^,\n]+)/i);
            if (mRu?.[1]) return mRu[1].trim();
            // Иногда встречается "қ. <қала>"
            const mKz = str.match(/қ\.\s*([^,\n]+)/i);
            if (mKz?.[1]) return mKz[1].trim();
            // Для протокола не извлекаем "город" из произвольного названия подразделения
            // (например, "Туркестанское городское отделение"), иначе появляется дублирование.
            return "";
        };


        console.log('protocol:', protocol);
        // Город берем только из адресных полей (не из name подразделения),
        // чтобы не получить "г. <название отделения>".
        const cityRaw = protocol?.filialDivision?.addressLine ?? protocol?.filialDivision?.addressLineRu ?? protocol?.filialDivision?.addressLineRU
            ?? protocol?.filialDivision?.addressLineKz ?? protocol?.filialDivision?.addressLineKZ
            ?? protocol?.filial?.addressLine ?? protocol?.filial?.addressLineRu ?? protocol?.filial?.addressLineRU
            ?? protocol?.filial?.addressLineKz ?? protocol?.filial?.addressLineKZ ?? "";
        const city = extractCity(cityRaw).replace(/^(город|қала)\s+/i, "").trim();
        const cityLine = city ? `г. ${city}` : "";
        const normalizeForCompare = (s) => String(s ?? "")
            .toLowerCase()
            .replace(/^г\.\s*/i, "")
            .replace(/\s+/g, " ")
            .trim();

        const stripCityFromName = (name, cityValue) => {
            if (!name) return "";
            if (!cityValue) return String(name).trim();
            const c = escapeRegExp(cityValue);
            return String(name)
                // "г. город Павлодар" / "г. Павлодар"
                .replace(new RegExp(`\\s*г\\.?\\s*(город\\s*)?${c}\\b`, "ig"), "")
                // "город Павлодар"
                .replace(new RegExp(`\\s*город\\s*${c}\\b`, "ig"), "")
                // "қ. Павлодар"
                .replace(new RegExp(`\\s*қ\\.?\\s*${c}\\b`, "ig"), "")
                .replace(/\s{2,}/g, " ")
                .replace(/\n{2,}/g, "\n")
                .replace(/[,\s]+$/g, "")
                .trim();
        };

        const filialNameKzClean = stripCityFromName(filialNameKz, city);
        const filialNameRuClean = stripCityFromName(filialNameRu, city);

        // Формат как в макете: KZ филиал, KZ районное отделение (если есть), пустая строка, RU филиал, RU районное отделение (если есть), затем "г. <город>"
        const branchParts = [];
        if (filialNameKzClean) branchParts.push(filialNameKzClean);
        if (filialDivisionNameKz) branchParts.push(filialDivisionNameKz);
        if ((filialNameKzClean || filialDivisionNameKz) && (filialNameRuClean || filialDivisionNameRu || cityLine)) branchParts.push(""); // пустая строка между языками
        if (filialNameRuClean) branchParts.push(filialNameRuClean);
        if (filialDivisionNameRu) branchParts.push(filialDivisionNameRu);
        const cityDuplicatesDivision =
            cityLine &&
            (
                normalizeForCompare(cityLine) === normalizeForCompare(filialDivisionNameRu) ||
                normalizeForCompare(cityLine) === normalizeForCompare(filialDivisionNameKz)
            );
        if (cityLine && !cityDuplicatesDivision) branchParts.push(cityLine);


        const branchText = branchParts.length ? branchParts.join("\n") : branchTextFallback;

        const department = protocol?.department;
        const labNameRu =
            department?.name ??
            department?.nameRu ??
            department?.nameRU ??
            department?.description ??
            "";

        // В справочнике лабораторий (Department) часто нет отдельного поля nameKz.
        // Если KZ не пришло — используем реальное RU-название (лучше, чем общий fallback).
        const labNameKz =
            department?.nameKz ??
            department?.nameKZ ??
            department?.name_kz ??
            department?.descriptionKz ??
            department?.descriptionKZ ??
            // если KZ не пришло с бэка — берём из "справочника" переводов
            translateLaboratoryNameToKz(labNameRu) ??
            // и только в самом конце — RU как fallback
            labNameRu ??
            "";

        const labText = `${labNameKz || "Бактериологиялық зертхана"}\n${labNameRu || "Бактериологическая лаборатория"}`;

        const normalizeFormNumberForHeader = (n) => {
            const s = String(n ?? "").trim();
            if (!s) return "";
            // если номер числовой — форматируем как 3 цифры (74 -> 074)
            if (/^\d+$/.test(s)) return s.padStart(3, "0");
            return s;
        };
        const formNumberRaw = protocol?.form?.number || form?.number || "024";
        const formNumberForHeader = normalizeFormNumberForHeader(formNumberRaw) || "024";
        const docInfoTextKz = `Қазақстан Республикасының Денсаулық сақтау министрінің 2021 жылғы 20 тамыздағы №ҚР ДСМ-84 бұйрығымен бекітілген №${formNumberForHeader} нысанды медициналық құжаттама`;

        const docInfoTextRu = `Медицинская документация
Форма №${formNumberForHeader} Утверждена приказом Министра здравоохранения Республики Казахстан от 20 августа 2021 года №ҚР ДСМ-84`;

        // Первый столбец (с логотипами) — делаем шире, чтобы совпадало с макетом
        // +10 — запас под стандартные паддинги ячейки pdfmake, +10мм — дополнительный запас по требованию
        const logosRowFirstCol = hasOptionalLogo ? ilacW : filialLogoW;
        const logosCellWidth = logosRowFirstCol + logoSpacing + filialLogoW + 10 + mmToPt(10);
        const logosRow = {
            layout: {
                defaultBorder: false,
                paddingLeft: () => 0,
                paddingRight: () => 0,
                paddingTop: () => 0,
                paddingBottom: () => 0,
            },
            table: {
                widths: [logosRowFirstCol, logoSpacing, filialLogoW],
                body: [[images[0] || '', '', images[1] || '']]
            }
        };

        const docDefinition = {
            watermark: { angle: -70, text: 'Қазақстан Республикасы Денсаулық сақтау министрлігі Санитариялық-эпидемиологиялық бақылау комитетінің «Ұлттық сараптама орталығы» шаруашылық жүргізу құқығындағы республикалық мемлекеттік кәсіпорны', color: 'gray', opacity: 0.3, bold: true, italics: false, fontSize: 20 },
            info: {
                title: 'Протокол',
                author: 'NCE',
                subject: 'Result'
            },
            pageOrientation: pageOrientation === 'landscape'
                ? 'landscape'
                : pageOrientation === 'portrait'
                    ? 'portrait'
                    : isWide ? 'landscape' : 'portrait',
            pageSize: 'A4',
            // Оставляем отдельное место под footer, чтобы нумерация не накладывалась на контент.
            pageMargins: [56, 28, 28, 48],
            footer: (currentPage, pageCount) => ({
                text: `Страница ${currentPage} из ${pageCount}`,
                alignment: 'center',
                fontSize: 9,
                margin: [0, 0, 0, 8],
            }),
            defaultStyle: {
                font: 'TimesNewRoman',
            },
            //pageMargins: [56, 28, 28, 28],            
            // pageOrientation: 'landscape',
            // pageSize: 'A4',
            // pageMargins: [56, 28, 28, 28],
            content:
                [
                    {
                        // Шапка протокола — весь текст шрифтом 8 (как в макете)
                        fontSize: 8,
                        bold: false,
                        table: {
                            widths: [logosCellWidth, '*', '*'],
                            body: [
                                [
                                    { stack: [logosRow], alignment: 'left' },
                                    { text: accreditationText, style: 'header', alignment: 'center' },
                                    { text: codeText, style: 'header' }
                                ],
                                [
                                    { text: ministryText, style: 'header' },
                                    { text: labText, style: 'header', alignment: 'center', rowSpan: 2 },
                                    { text: docInfoTextKz, style: 'header' }
                                ],
                                [
                                    { text: branchText, style: 'header' },
                                    '',
                                    { text: docInfoTextRu, style: 'header' }
                                ]
                            ]
                        }
                    },
                    { text: `${form?.kazakhName + '\n' + form?.name}`, fontSize: 14, alignment: 'center', marginTop: 10, bold: true },
                    {
                        text: `№${protocol.number} ${Intl.DateTimeFormat('ru-RU', {
                            day: 'numeric',
                            month: 'numeric',
                            year: 'numeric'
                        }).format(dateOfIssue)} ж. (г.)`, fontSize: 12, alignment: 'center', marginTop: 10, marginBottom: 10
                    },
                    {
                        table: {
                            // headers are automatically repeated if the table spans over multiple pages
                            // you can declare how many rows should be treated as headers
                            //dontBreakRows: true,
                            headerRows: 0,
                            widths: ['*'],
                            body: content,
                            //    pageBreak: 'auto',
                            layout: {
                                fillColor: function (rowIndex, node, columnIndex) {
                                    return null;
                                }
                            }
                        },
                    },
                    ...htmlTablesContent,
                    {
                        layout: 'noBorders',
                        marginTop: 10,
                        pageBreak: shouldBreakBeforeSignatures ? 'before' : undefined,
                        table: {
                            //     dontBreakRows: true,
                            headerRows: 0,
                            widths: ['*', '*', '*'],
                            body: [
                                [
                                    `${renderEmployeePosition(protocolData?.research_specialist)}`,
                                    signers.research_specialist ? 'Қол қойылды(Подписано)' : 'Қолы (Подпись)',
                                    `${renderEmployeeName(protocolData?.research_specialist)}`
                                ],
                                [
                                    `${renderEmployeePosition(protocolData?.lab_director)}`,
                                    signers.lab_director ? 'Қол қойылды(Подписано)' : 'Қолы (Подпись)',
                                    `${renderEmployeeName(protocolData?.lab_director)}`
                                ],
                                [
                                    `${renderEmployeePosition(protocolData?.organization_leader)}`,
                                    signers.organization_leader ? 'Қол қойылды(Подписано)' : 'Қолы (Подпись)',
                                    `${renderEmployeeName(protocolData?.organization_leader)}`
                                ]
                            ],
                        }
                    },
                    {
                        text: `
                    Хаттама __ данада толтырылды (Протокол составлен в ___ экземплярах)
                    Хаттама берілген күні (Дата выдачи протокола) ${Intl.DateTimeFormat('ru-RU', {
                            day: 'numeric',
                            month: 'numeric',
                            year: 'numeric'
                        }).format(dateOfIssue) + " ж. (г.)"}
                    Парақтар саны (Количество страниц)
                    Сынау нәтижелері тек қана сыналуға жататын үлгілерге қолданылады
                    (Результаты исследования распространяются только на образцы, подвергнутые испытаниям)
                    Рұқсатсыз хаттаманы жартылай қайта басуға ТЫЙЫМ САЛЫНҒАН
                    (Частичная перепечатка протокола без разрешения ЗАПРЕЩЕНА)${protocol.form?.number !== '34' ? `
                    Санитариялық дәрігердің немесе гигиенист дәрігердің зерттелген өнімдердің,химиялық заттардың, физикалық және радиациялық факторлардың үлгілері/сынамалары туралы қорытындысы
                    (Заключение санитарного врача или врача-гигиениста по образцам/пробам исследуемой продукции, химических веществ, физических и радиационных факторов):
                    ____________________________________________________________________ ____________________________________________________________________` : ''}
                    `, fontSize: 8, alignment: 'left', marginTop: 10, bold: false
                    },

                    { image: qrLink },
                ],
            styles: {
                header: {
                    alignment: 'left',
                    margin: [0, 5],
                    fontSize: 8,
                    bold: false
                },
                bigHeader: {
                    alignment: 'center',
                    margin: [0, 0, 0, 10],
                    fontSize: 16,
                    bold: true
                },
                table: {
                    fontSize: 5,
                    margin: [0, 0, 10, 0],
                    border: '5px'
                },
                td: {
                    size: 1
                },
                text: {
                    fontSize: 11,
                    margin: [0, 0, 0, 0],
                },
            },
        };

        pdfMake.fonts = {
            // All 4 components must be defined
            TimesNewRoman: {
                normal: 'Times-Regular.ttf',
                bold: 'Times-Bold.ttf',
                italics: 'Times-Italic.ttf',
                bolditalics: 'Times-BoldItalic.ttf'
            },
            Roboto: {
                normal: 'Roboto-Regular.ttf',
                bold: 'Roboto-Medium.ttf',
                italics: 'Roboto-Italic.ttf',
                bolditalics: 'Roboto-MediumItalic.ttf'
            }
        };
        // pdfMake.fonts.TimesNewRoman = {
        //     normal: 'Times-New-Roman-Regular.ttf',
        //     bold: 'Times-New-Roman-Bold.ttf',
        //     italics: 'Times-New-Roman-Italic.ttf',
        //     bolditalics: 'Times-New-Roman-BoldItalic.ttf'
        // };

        // Очищаем все NaN значения из определения документа перед возвратом
        return sanitizeNaNValues(docDefinition);
    }
}

export default ProtocolPdfModel;
